import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _importIconMapper;
import React from 'react';
import Loadable from 'react-loadable';
import { R400 } from '@atlaskit/theme/colors';
import { ConfluenceIcon, JiraIcon } from '@atlaskit/logo';
import DocumentIcon from '@atlaskit/icon-file-type/glyph/document/16';
import BlogIcon from '@atlaskit/icon-object/glyph/blog/16';
import { IconType } from '../../../../../constants';
// prettier-ignore
var importIconMapper = (_importIconMapper = {}, _defineProperty(_importIconMapper, IconType.Archive, function () {
  return import( /* webpackChunkName: "glyphArchive" */'@atlaskit/icon-file-type/glyph/archive/16');
}), _defineProperty(_importIconMapper, IconType.Audio, function () {
  return import( /* webpackChunkName: "glyphAudio" */'@atlaskit/icon-file-type/glyph/audio/16');
}), _defineProperty(_importIconMapper, IconType.Code, function () {
  return import( /* webpackChunkName: "glyphCode" */'@atlaskit/icon-file-type/glyph/source-code/16');
}), _defineProperty(_importIconMapper, IconType.Executable, function () {
  return import( /* webpackChunkName: "glyphExecutable" */'@atlaskit/icon-file-type/glyph/executable/16');
}), _defineProperty(_importIconMapper, IconType.File, function () {
  return import( /* webpackChunkName: "glyphFile" */'@atlaskit/icon-file-type/glyph/generic/16');
}), _defineProperty(_importIconMapper, IconType.Folder, function () {
  return import( /* webpackChunkName: "glyphFolder" */'@atlaskit/icon-file-type/glyph/folder/16');
}), _defineProperty(_importIconMapper, IconType.Generic, function () {
  return import( /* webpackChunkName: "glyphGeneric" */'@atlaskit/icon-file-type/glyph/generic/16');
}), _defineProperty(_importIconMapper, IconType.GIF, function () {
  return import( /* webpackChunkName: "glyphGIF" */'@atlaskit/icon-file-type/glyph/gif/16');
}), _defineProperty(_importIconMapper, IconType.GoogleDocs, function () {
  return import( /* webpackChunkName: "glyphGoogleDocs" */'@atlaskit/icon-file-type/glyph/google-doc/16');
}), _defineProperty(_importIconMapper, IconType.GoogleForms, function () {
  return import( /* webpackChunkName: "glyphGoogleForms" */'@atlaskit/icon-file-type/glyph/google-form/16');
}), _defineProperty(_importIconMapper, IconType.GoogleSheets, function () {
  return import( /* webpackChunkName: "glyphGoogleSheets" */'@atlaskit/icon-file-type/glyph/google-sheet/16');
}), _defineProperty(_importIconMapper, IconType.GoogleSlides, function () {
  return import( /* webpackChunkName: "glyphGoogleSlides" */'@atlaskit/icon-file-type/glyph/google-slide/16');
}), _defineProperty(_importIconMapper, IconType.Image, function () {
  return import( /* webpackChunkName: "glyphImage" */'@atlaskit/icon-file-type/glyph/image/16');
}), _defineProperty(_importIconMapper, IconType.MSExcel, function () {
  return import( /* webpackChunkName: "glyphMSExcel" */'@atlaskit/icon-file-type/glyph/excel-spreadsheet/16');
}), _defineProperty(_importIconMapper, IconType.MSPowerpoint, function () {
  return import( /* webpackChunkName: "glyphMSPowerpoint" */'@atlaskit/icon-file-type/glyph/powerpoint-presentation/16');
}), _defineProperty(_importIconMapper, IconType.MSWord, function () {
  return import( /* webpackChunkName: "glyphMSWord" */'@atlaskit/icon-file-type/glyph/word-document/16');
}), _defineProperty(_importIconMapper, IconType.PDF, function () {
  return import( /* webpackChunkName: "glyphPDF" */'@atlaskit/icon-file-type/glyph/pdf-document/16');
}), _defineProperty(_importIconMapper, IconType.Presentation, function () {
  return import( /* webpackChunkName: "glyphPresentation" */'@atlaskit/icon-file-type/glyph/presentation/16');
}), _defineProperty(_importIconMapper, IconType.Sketch, function () {
  return import( /* webpackChunkName: "glyphSketch" */'@atlaskit/icon-file-type/glyph/sketch/16');
}), _defineProperty(_importIconMapper, IconType.Spreadsheet, function () {
  return import( /* webpackChunkName: "glyphSpreadsheet" */'@atlaskit/icon-file-type/glyph/spreadsheet/16');
}), _defineProperty(_importIconMapper, IconType.Template, function () {
  return import( /* webpackChunkName: "glyphTemplate" */'@atlaskit/icon/glyph/document-filled');
}), _defineProperty(_importIconMapper, IconType.Video, function () {
  return import( /* webpackChunkName: "glyphVideo" */'@atlaskit/icon-file-type/glyph/video/16');
}), _defineProperty(_importIconMapper, IconType.Branch, function () {
  return import( /* webpackChunkName: "glyphBranch" */'@atlaskit/icon-object/glyph/branch/16');
}), _defineProperty(_importIconMapper, IconType.Commit, function () {
  return import( /* webpackChunkName: "glyphCommit" */'@atlaskit/icon-object/glyph/commit/16');
}), _defineProperty(_importIconMapper, IconType.Project, function () {
  return import( /* webpackChunkName: "glyphProject" */'@atlaskit/icon/glyph/people-group');
}), _defineProperty(_importIconMapper, IconType.PullRequest, function () {
  return import( /* webpackChunkName: "glyphPullRequest" */'@atlaskit/icon-object/glyph/pull-request/16');
}), _defineProperty(_importIconMapper, IconType.Repo, function () {
  return import( /* webpackChunkName: "glyphRepo" */'@atlaskit/icon-object/glyph/code/16');
}), _defineProperty(_importIconMapper, IconType.Bug, function () {
  return import( /* webpackChunkName: "glyphBug" */'@atlaskit/icon-object/glyph/bug/16');
}), _defineProperty(_importIconMapper, IconType.Change, function () {
  return import( /* webpackChunkName: "glyphChange" */'@atlaskit/icon-object/glyph/changes/16');
}), _defineProperty(_importIconMapper, IconType.Epic, function () {
  return import( /* webpackChunkName: "glyphEpic" */'@atlaskit/icon-object/glyph/epic/16');
}), _defineProperty(_importIconMapper, IconType.Incident, function () {
  return import( /* webpackChunkName: "glyphIncident" */'@atlaskit/icon-object/glyph/incident/16');
}), _defineProperty(_importIconMapper, IconType.Problem, function () {
  return import( /* webpackChunkName: "glyphProblem" */'@atlaskit/icon-object/glyph/problem/16');
}), _defineProperty(_importIconMapper, IconType.ServiceRequest, function () {
  return import( /* webpackChunkName: "glyphServiceRequest" */'@atlaskit/icon-object/glyph/issue/16');
}), _defineProperty(_importIconMapper, IconType.Story, function () {
  return import( /* webpackChunkName: "glyphStory" */'@atlaskit/icon-object/glyph/story/16');
}), _defineProperty(_importIconMapper, IconType.SubTask, function () {
  return import( /* webpackChunkName: "glyphSubTask" */'@atlaskit/icon-object/glyph/subtask/16');
}), _defineProperty(_importIconMapper, IconType.Task, function () {
  return import( /* webpackChunkName: "glyphTask" */'@atlaskit/icon-object/glyph/task/16');
}), _defineProperty(_importIconMapper, IconType.Confluence, function () {
  return import( /* webpackChunkName: "glyphConfluence" */'@atlaskit/logo/confluence-icon').then(function (_ref) {
    var ConfluenceIcon = _ref.ConfluenceIcon;
    return {
      default: ConfluenceIcon
    };
  });
}), _defineProperty(_importIconMapper, IconType.Jira, function () {
  return import( /* webpackChunkName: "glyphJira" */'@atlaskit/logo/jira-icon').then(function (_ref2) {
    var JiraIcon = _ref2.JiraIcon;
    return {
      default: JiraIcon
    };
  });
}), _defineProperty(_importIconMapper, IconType.Default, function () {
  return import( /* webpackChunkName: "glyphDefault" */'@atlaskit/icon/glyph/link');
}), _defineProperty(_importIconMapper, IconType.Error, function () {
  return import( /* webpackChunkName: "glyphError" */'@atlaskit/icon/glyph/error');
}), _defineProperty(_importIconMapper, IconType.Forbidden, function () {
  return import( /* webpackChunkName: "glyphForbidden" */'@atlaskit/icon/glyph/lock-filled');
}), _defineProperty(_importIconMapper, IconType.Attachment, function () {
  return import( /* webpackChunkName: "glyphAttachment" */'@atlaskit/icon/glyph/attachment');
}), _defineProperty(_importIconMapper, IconType.CheckItem, function () {
  return import( /* webpackChunkName: "glyphAttachment" */'@atlaskit/icon/glyph/task');
}), _defineProperty(_importIconMapper, IconType.Comment, function () {
  return import( /* webpackChunkName: "glyphComment" */'@atlaskit/icon/glyph/comment');
}), _defineProperty(_importIconMapper, IconType.View, function () {
  return import( /* webpackChunkName: "glyphComment" */'@atlaskit/icon/glyph/watch');
}), _defineProperty(_importIconMapper, IconType.React, function () {
  return import( /* webpackChunkName: "glyphComment" */'@atlaskit/icon/glyph/like');
}), _defineProperty(_importIconMapper, IconType.Vote, function () {
  return import( /* webpackChunkName: "glyphComment" */'@atlaskit/icon/glyph/arrow-up');
}), _defineProperty(_importIconMapper, IconType.PriorityBlocker, function () {
  return import( /* webpackChunkName: "glyphBlocker" */'@atlaskit/icon-priority/glyph/priority-blocker');
}), _defineProperty(_importIconMapper, IconType.PriorityCritical, function () {
  return import( /* webpackChunkName: "glyphCritical" */'@atlaskit/icon-priority/glyph/priority-critical');
}), _defineProperty(_importIconMapper, IconType.PriorityHigh, function () {
  return import( /* webpackChunkName: "glyphHigh" */'@atlaskit/icon-priority/glyph/priority-high');
}), _defineProperty(_importIconMapper, IconType.PriorityHighest, function () {
  return import( /* webpackChunkName: "glyphHighest" */'@atlaskit/icon-priority/glyph/priority-highest');
}), _defineProperty(_importIconMapper, IconType.PriorityLow, function () {
  return import( /* webpackChunkName: "glyphLow" */'@atlaskit/icon-priority/glyph/priority-low');
}), _defineProperty(_importIconMapper, IconType.PriorityLowest, function () {
  return import( /* webpackChunkName: "glyphLowest" */'@atlaskit/icon-priority/glyph/priority-lowest');
}), _defineProperty(_importIconMapper, IconType.PriorityMajor, function () {
  return import( /* webpackChunkName: "glyphMajor" */'@atlaskit/icon-priority/glyph/priority-major');
}), _defineProperty(_importIconMapper, IconType.PriorityMedium, function () {
  return import( /* webpackChunkName: "glyphMedium" */'@atlaskit/icon-priority/glyph/priority-medium');
}), _defineProperty(_importIconMapper, IconType.PriorityMinor, function () {
  return import( /* webpackChunkName: "glyphMinor" */'@atlaskit/icon-priority/glyph/priority-minor');
}), _defineProperty(_importIconMapper, IconType.PriorityTrivial, function () {
  return import( /* webpackChunkName: "glyphTrivial" */'@atlaskit/icon-priority/glyph/priority-trivial');
}), _defineProperty(_importIconMapper, IconType.PriorityUndefined, function () {
  return import( /* webpackChunkName: "glyphUndefined" */'@atlaskit/icon/glyph/question');
}), _defineProperty(_importIconMapper, IconType.ProgrammingLanguage, function () {
  return import( /* webpackChunkName: "glyphProgrammingLanguage" */'@atlaskit/icon/glyph/code');
}), _defineProperty(_importIconMapper, IconType.Subscriber, function () {
  return import( /* webpackChunkName: "glyphSubscriber" */'@atlaskit/icon/glyph/people');
}), _defineProperty(_importIconMapper, IconType.SubTasksProgress, function () {
  return import( /* webpackChunkName: "glyphSubtaskProgress" */'@atlaskit/icon/glyph/subtask');
}), _importIconMapper);
var getIconImportFn = function getIconImportFn(icon) {
  return importIconMapper[icon];
};
var importIcon = function importIcon(importFn) {
  return Loadable({
    loader: function loader() {
      return importFn().then(function (module) {
        return module.default;
      });
    },
    loading: function loading() {
      return null;
    }
  }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
var AtlaskitIcon = function AtlaskitIcon(_ref3) {
  var icon = _ref3.icon,
    label = _ref3.label,
    testId = _ref3.testId;
  // Check for synchonously loaded icons first for SSR purposes
  switch (icon) {
    case IconType.Document:
      return /*#__PURE__*/React.createElement(DocumentIcon, {
        label: label || 'document',
        testId: testId
      });
    case IconType.Blog:
      // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
      return /*#__PURE__*/React.createElement(BlogIcon, {
        label: label || 'blog',
        testId: testId
      });
  }
  var importFn = getIconImportFn(icon);
  if (!importFn) {
    return null;
  }
  var ImportedIcon = importIcon(importFn);
  switch (icon) {
    case IconType.Confluence:
      return /*#__PURE__*/React.createElement(ConfluenceIcon, {
        appearance: "brand",
        testId: testId
      });
    case IconType.Jira:
      return /*#__PURE__*/React.createElement(JiraIcon, {
        appearance: "brand",
        testId: testId
      });
    case IconType.Error:
    case IconType.Forbidden:
      return /*#__PURE__*/React.createElement(ImportedIcon, {
        label: label,
        testId: testId,
        primaryColor: "var(--ds-icon-danger, ".concat(R400, ")")
      });
    default:
      return /*#__PURE__*/React.createElement(ImportedIcon, {
        label: label,
        testId: testId
      });
  }
};
export default AtlaskitIcon;